
<template>
    <svg viewBox="0 0 8 8" class="icon ml-1">
        <use :xlink:href="href"></use>
    </svg>
</template>

<script>
    import Vue from 'vue'

    export default Vue.extend({
        name: 'ShsIcon',
        props: {
            name: String
        },
        computed: {
            href() {
                return '/images/open-iconic/open-iconic.svg#' + this.name
            }
        }
    })
</script>
